import { HOME_ROUTE, ROUTE_BY_PATH, ROUTE_BY_ID, type Route } from './routes';

const stripHash = (raw: string): string => {
  const hash = raw.startsWith('#') ? raw.slice(1) : raw;
  if (hash === '' || hash === '/') return '/';
  if (hash.startsWith('/')) return hash;
  // In-page anchors (e.g. "#how", "#pricing") are not routes.
  return '/';
};

const trimSlash = (s: string): string => {
  if (s.length > 1 && s.endsWith('/')) return s.slice(0, -1);
  return s;
};

export const currentRoute = (): Route => {
  // Build-time SEO plugin sets window.__ANOMIA_ROUTE__ on per-route HTML;
  // honor it first so navigation between pre-built pages doesn't depend on
  // path-resolution heuristics.
  const w = window as Window & { __ANOMIA_ROUTE__?: string };
  if (typeof w.__ANOMIA_ROUTE__ === 'string') {
    const fromWindow = ROUTE_BY_ID.get(w.__ANOMIA_ROUTE__);
    if (fromWindow) return fromWindow;
  }
  const fromPath = ROUTE_BY_PATH.get(trimSlash(window.location.pathname));
  if (fromPath) return fromPath;
  const fromHash = ROUTE_BY_PATH.get(stripHash(window.location.hash));
  if (fromHash) return fromHash;
  return HOME_ROUTE;
};

export const onRouteChange = (handler: (route: Route) => void): (() => void) => {
  const fire = (): void => {
    handler(currentRoute());
  };
  window.addEventListener('hashchange', fire);
  fire();
  return () => {
    window.removeEventListener('hashchange', fire);
  };
};
